<style>
    .person {
        color: #fff;
    }
    .footer {
        margin-left: 10px;
    }

</style>

<template>
    <v-app>
      <v-navigation-drawer app v-model="drawer" :permanent="drawer" hide-overlay width="200" v-if="$auth.user()">
        <v-toolbar flat class="transparent">
          <v-list class="pa-0">
            <v-list-tile avatar>
              <v-list-tile-content>
                <v-list-tile-title class="person">{{ $auth.user().displayName || $auth.user().email }}</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
          </v-list>
        </v-toolbar>
        <v-list>
         <v-list-tile @click="$router.push('/realtime-database')">
            <v-list-tile-content>
              <v-list-tile-title>Kalkulator</v-list-tile-title>
            </v-list-tile-content>
         </v-list-tile>
         <v-list-tile @click="$router.push('/Solarspot')">
            <v-list-tile-content>
              <v-list-tile-title>Ustalenia montażowe</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
                   <v-list-tile @click="$router.push('/Kontakt')">
            <v-list-tile-content>
              <v-list-tile-title>Kontakt z projektantem</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
          <v-list-tile @click="$router.push('/update-profile')">
            <v-list-tile-content>
              <v-list-tile-title>Aktualizacja profilu</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
          <v-list-tile @click="logout()">
            <v-list-tile-content>
              <v-list-tile-title>Wyloguj się</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-list>
      </v-navigation-drawer>
      <v-toolbar app >
        <v-toolbar-side-icon @click.native="drawer = !drawer" v-if="$auth.user()"></v-toolbar-side-icon>
        <img src="./../assets/img/logo-mini.png" style="height: 36px;" alt="SolarSpot logo" class="logo" >
        <v-toolbar-title>App</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-toolbar-items class="hidden-sm-and-down">
          <v-btn flat v-if="$auth.user()" @click="logout()">Wyloguj się</v-btn>
          <v-btn flat v-else @click="login()">Zaloguj się</v-btn>
        </v-toolbar-items>
      </v-toolbar>
      <v-content>
        <v-container>
          <router-view></router-view>
        </v-container>
      </v-content>
      <v-footer app>
        <span class="footer">&copy; 2019 www.ecoprojektant.pl</span>
        <v-spacer></v-spacer>
      </v-footer>
    </v-app>
</template>
<script>
import RoutesUtils from '@/router/utils'

export default {
  mounted () {
    this.$auth
      .check()
      .then(user => {})
      .catch(err => {})
  },
  data () {
    return {
      items: [
        { title: 'Real time Database', link: 'dashboard' },
        { title: 'Cloud Firestore', link: 'account_box' },
      ],
      drawer: true,
      RoutesUtils: RoutesUtils.navigarion
    }
  },
  methods: {
    logout () {
      this.$auth.logout().then(() => {
        this.$router.push('/login')
      })
    },
    login () {
      this.$router.push('/login')
    }
  },
}
</script>



// WEBPACK FOOTER //
// Layout.vue?5e7d9fe8